const typography = {
  fontFamily: "'Sarabun', sans-serif",
};

export default typography;
